import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/unlicensed/license.unlicensed.query.gql"
import type {
  UnlicensedCustomersQuery,
  UnlicensedCustomersQueryVariables,
} from "@/v2-backoffice-client/license/unlicensed/__types__/license.unlicensed.query"

type Options = QueryHookOptions<
  UnlicensedCustomersQuery,
  UnlicensedCustomersQueryVariables
>

export function useUnlicensedCustomersQuery(options?: Options) {
  return useQuery<UnlicensedCustomersQuery, UnlicensedCustomersQueryVariables>(
    query,
    options,
  )
}
